export default {
  form: {
    should_save_payment_info: {
      label: 'Tallenna maksutiedot nopeampaa kassalle siirtymistä varten',
    },
  },
};
